import AwaitingPaymentPlaceholder from './awaiting-payment';
import OnHoldPlaceholder from './on-hold';
import { AwaitingShipmentPlaceholderWrapper } from './awaiting-shipment';
import OrdersShippedPlaceholder from './orders-shipped';
import CancelledPlaceholder from './cancelled';
import RejectedFulfillmentPlaceholder from './rejected-fulfillment';
import BatchesPlaceholder from '../../../shipping-page/grid-placeholder';
import QuicksearchPlaceholder from './quicksearch';
import AdvancedSearchPlaceholder from './advanced-search';

export default {
  'advanced-search': AdvancedSearchPlaceholder,
  'all-orders-search-result': QuicksearchPlaceholder,
  'awaiting-payment': AwaitingPaymentPlaceholder,
  'on-hold': OnHoldPlaceholder,
  'awaiting-shipment': AwaitingShipmentPlaceholderWrapper,
  shipped: OrdersShippedPlaceholder,
  cancelled: CancelledPlaceholder,
  'rejected-fulfillment': RejectedFulfillmentPlaceholder,
  batches: BatchesPlaceholder,
  filtering: AdvancedSearchPlaceholder,
};
